import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import TableHeader from '../../../../components/Table/TableHeader';
import TablePagination from '../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../components/InputSearch'

const tabelaColunas = ['Nome', 'E-mail', 'Status', '']

const ListaAdministradores = ({ response, buscar, busca, mudarPagina }) => {

    const history = useHistory();

    const changePage = (page) => {
        mudarPagina(page)
    }

    const [novaLista, setNovaLista] = useState([]);
    const gotoDet = (userId) => {
        history.push(`/admin/administrador/${userId}`)
    }

    useEffect(() => {
        setNovaLista(response.lista);
    }, [response]);

    return (
        <div className="administradores-lista">
            <div className="row">
                <div className="col-12">
                    <div className="table-responsive">
                        <table className="table table-sm table-striped">
                            <thead>
                                <tr>
                                    <th
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            var lista = [...novaLista];
                                            const sorted = lista.sort(
                                                (a, b) => a.nome - b.nome
                                            );
                                            const isReversed =
                                                novaLista[0]?.nome === sorted[0]?.nome;
                                            setNovaLista(isReversed ? sorted.reverse() : sorted);
                                        }}
                                    >
                                        Nome
                                    </th>
                                    <th
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            var lista = [...novaLista];
                                            const sorted = lista.sort(
                                                (a, b) => a.email - b.email
                                            );
                                            const isReversed =
                                                novaLista[0]?.email === sorted[0]?.email;
                                            setNovaLista(isReversed ? sorted.reverse() : sorted);
                                        }}
                                    >
                                        E-mail
                                    </th>
                                    <th
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            var lista = [...novaLista];
                                            const sorted = lista.sort(
                                                (a, b) => a.ativo - b.ativo
                                            );
                                            const isReversed =
                                                novaLista[0]?.ativo === sorted[0]?.ativo;
                                            setNovaLista(isReversed ? sorted.reverse() : sorted);
                                        }}
                                    >
                                        Status
                                    </th>
                                    <th style={{ cursor: "pointer" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {(!novaLista || novaLista.length === 0) && (
                                    <tr>
                                        <td colSpan={tabelaColunas.length}> Sem Registros </td>
                                    </tr>
                                )}
                                {novaLista &&
                                    novaLista.map((user) => (
                                        <tr key={user.id}>
                                            <td>{user.nome}</td>
                                            <td>{user.email}</td>
                                            <td>{user.ativo ? 'Ativo' : 'Inativo'}</td>
                                            <td className="text-right">
                                                <i
                                                    className="btn-edit-icon btn btn-icon fa fa-edit"
                                                    onClick={() => gotoDet(user.id)}
                                                ></i>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                        <TablePagination data={response} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ListaAdministradores;